import { render, staticRenderFns } from "./createPredictionModal.vue?vue&type=template&id=0b17ac5c&scoped=true&"
import script from "./createPredictionModal.vue?vue&type=script&lang=js&"
export * from "./createPredictionModal.vue?vue&type=script&lang=js&"
import style0 from "./createPredictionModal.vue?vue&type=style&index=0&id=0b17ac5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17ac5c",
  null
  
)

export default component.exports